export const createTest = (payload?: any) => ({
    type: "@saga/CREATE_TEST",
    payload
});

